import {combineReducers} from '@reduxjs/toolkit';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

/**
 * Customers row-selection slice (FNP-951 / FNP-918).
 *
 * ── TEMPLATE FOR THE OTHER 14 MODULES ──
 * Copy this file, change `entityKey`, then register the exported reducer in
 * `src/store/index.ts` under the SAME key. Nothing else in the store changes.
 *
 * `combineReducers` wraps the slice under a `selection` key so a module can
 * later gain sibling slices (filter, sorting, visibility) without moving the
 * selection state or touching its consumers.
 */
const entityKey = 'customers';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    addManyToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const CustomersReducer = combineReducers({
    selection: selectionSlice.reducer,
});
